export enum enumDutiesCalculationStatus {
  Success,
  RateNotParsed,
  CountryNotSupported,
  HtsCodeNotSupported,
}
